import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
import { TCategory } from '@api/io/categories.io';
import { TW_ROOT } from '@utils/constants';
import { cn, FaIcon } from '@fe-learner-common';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { CategoryLinkItem } from '@routes/catalog/components/Categories/CategoryLinkItem';
import { useIntl } from 'react-intl';
import { useBreakpoint } from '@fe-learner-common/hooks/useBreakpoint';

type MoreCategoriesMenuProps = {
  categories: TCategory[];
};
export const MoreCategoriesMenu = forwardRef<
  HTMLButtonElement,
  MoreCategoriesMenuProps
>(({ categories }, ref) => {
  const intl = useIntl();
  const matchesMd = useBreakpoint('md');

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          ref={ref}
          className="lf:l-btn lf:l-btn-md lf:l-btn-secondary lf:shrink-0 lf:text-nowrap lf:data-[state=open]:bg-neutral-300"
          aria-label={intl.formatMessage({ id: 'catalog.categories.more' })}
        >
          <span>{intl.formatMessage({ id: 'catalog.categories.more' })}</span>
          <FaIcon icon={faChevronDown} />
        </button>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal
        container={document.getElementById(TW_ROOT) as HTMLElement}
      >
        <DropdownMenu.Content
          avoidCollisions
          side="bottom"
          collisionPadding={matchesMd ? 50 : 16}
          loop={true}
          className={cn(
            'lf:mt-[20px] lf:flex lf:max-h-[70vh] lf:max-w-[calc(100vw-32px)] lf:flex-wrap lf:gap-3 lf:overflow-auto lf:rounded-xl lf:border-1 lf:border-neutral-200 lf:bg-neutral-0 lf:p-4 lf:drop-shadow-lg',
            'lf:md:max-h-[500px] lf:md:max-w-[600px]',
          )}
        >
          {categories.map((category) => (
            <DropdownMenu.Item key={category.id} asChild>
              <CategoryLinkItem category={category} />
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
});
MoreCategoriesMenu.displayName = 'MoreCategoriesMenu';
